import React, { useState } from 'react'
import DeviceIco from '../../../../components/icons/DeviceIco'
import ButtonForm from '../../../../components/ButtonForm'
import Modal from '../../../../components/Modal'
import DashboardForm from './DashboardForm'
import { useDashboards } from '../../../../providers/DashboardContext'


function NoDashboards() {
  const [newDashboardModal, setNewDashboardModal] = useState(false);
  const {module, refreshCurrentDashboard} = useDashboards()
  const toggleNewDashboardModal = (event) => {
    setNewDashboardModal((prev) => !prev);
  };

  const refreshTable = () => {
    refreshCurrentDashboard();
  };

  return (
    <div className='flex flex-col gap-3 items-center justify-center mt-10'>
      {/* Modal de edicion */}
      <Modal
        isOpen={newDashboardModal}
        onClose={() => {
          setNewDashboardModal(false);
        }}
        title={"Información del tablero"}
        customType={2}
        colorTitle="bg-bluesens"
        size="w-2/4"
      >
        <DashboardForm
          toggle={toggleNewDashboardModal}
          module={module}
          refreshList={refreshTable}
        />
      </Modal>
      <DeviceIco width='200px' height='200px' fill='bluesens'/>
      <span className='text-base font-semibold text-bluesens' >No existen dashboards por el momento</span>
      <span >Cree un dashboard para monitorear sus procesos</span>
      <ButtonForm text={"Crear Dashboard"} enabled={true} action={() => {toggleNewDashboardModal()}}/>
    </div>
  )
}

export default NoDashboards